import {
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";

interface Props {
  quantity: number;
  handleSelectQuantity: (q: number) => void;
  options: number[];
}

const QuantitySelection = ({
  quantity,
  handleSelectQuantity,
  options,
}: Props) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const page = "payment-information";

  return (
    <Stack gap={1}>
      <Typography variant={isMobile ? "body1" : "h6"} fontWeight={600}>
        {t(`${page}.dashboard.select-label`, "Quantity")}
      </Typography>
      <FormControl>
        <Select
          value={quantity}
          onChange={(e) => handleSelectQuantity(Number(e.target.value))}
        >
          {options.map((q, idx) => (
            <MenuItem key={idx} value={q}>
              {q}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};

export default QuantitySelection;
